const isLinkBackToTheSamePage = require("./isLinkBackToTheSamePage");

/**
 * @param a {HTMLAnchorElement}
 * @returns {boolean}
 */
module.exports = function isAnchorHrefEmpty(a) {
    const hrefTrimmed = a.href.trim();
    return hrefTrimmed === '' || hrefTrimmed === '#' || isLinkBackToTheSamePage(a.href);
}
